import React, { forwardRef, useImperativeHandle } from 'react'
import '../../styles/Input/InputDate.css'
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar } from '@fortawesome/free-solid-svg-icons'

const InputDate = forwardRef((props, ref) => {

    useImperativeHandle(ref, () => ({
        dateValidation: (date) => dateValidation(date)
    }))

    function onChange(date) {

        props.setDate(date)
        dateValidation(date)

    }

    function dateValidation(date) {

        // if (date) {
        //     props.setDateError(false)
        //     return true
        // } else {
        //     props.setDateError(true)
        //     return false
        // }

        props.setDateError(null)
        return true

    }

    return (

        <div className='inputDateContainer'>
            <div className={props.dateError == null ? 'inputDateIcon' : !props.dateError ? 'inputDateIconSuccess' : 'inputDateIconError'}>
                {props.icon ? props.icon : <FontAwesomeIcon icon={faCalendar} fontSize={16} />}
            </div>
            <DatePicker
                dateFormat={'dd/MM/yyyy'}
                selected={props.date}
                onChange={(date) => onChange(date)}
                className={props.dateError == null ? 'inputDate' : !props.dateError ? 'inputDateSuccess' : 'inputDateError'}
                placeholderText={props.placeholder ? props.placeholder : "Date"}
            />
        </div>

    )

})

export default InputDate
